import React, { useSyncExternalStore } from 'react'
import { Stack, useMediaQuery, useTheme } from '@mui/material'
import { B1BatteryAutonomy } from '@e3dc-react/icons'
import BatteryBadge from '../../BatteryBadge'
import { LineChartStore } from 'src/Libs/ai-360/store'

const AI360EmsBatteryLegend: React.FC = () => {
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))
  const { emsBatteryMode } = useSyncExternalStore(LineChartStore.subscribe, LineChartStore.get)

  return (
    <Stack flexDirection="column" maxWidth={upMd ? '300px' : '30vw'} minWidth={upMd ? '300px' : '30vw'} paddingRight={upMd ? 4 : 1}>
      <Stack flexDirection="row" justifyContent="space-between" gap={2} ml={2}>
        <B1BatteryAutonomy />
        <BatteryBadge status={emsBatteryMode} />
      </Stack>
    </Stack>
  )
}

export default AI360EmsBatteryLegend
